module.exports = __webpack_public_path__ + "img/vizio2-cover-2.03d2e83d.jpg";